module.exports = __webpack_public_path__ + "img/order_pending.383f66bb.svg";